<svg
  width="18px"
  height="18px"
  viewBox="0 0 18 18"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <g id="web/icon/close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <rect id="Rectangle" x="0" y="0" width="18" height="18"></rect>
    <circle id="Oval" stroke="#000000" stroke-width="2" cx="9" cy="9" r="8"></circle>
    <line
      x1="9"
      y1="5"
      x2="9"
      y2="13"
      id="Path-11"
      stroke="#000000"
      stroke-width="2"
      stroke-linecap="round"
      transform="translate(9, 9) rotate(-315) translate(-9, -9)"
    ></line>
    <line
      x1="5"
      y1="9"
      x2="13"
      y2="9"
      id="Path-12"
      stroke="#000000"
      stroke-width="2"
      stroke-linecap="round"
      transform="translate(9, 9) rotate(-315) translate(-9, -9)"
    ></line>
  </g>
</svg>
